<div class="phone-input-container" [class.has-error]="error">
	@if (label) {
		<label [for]="phoneInputId" class="phone-label">{{ label | transloco }}@if (required) {<span class="required-mark" aria-hidden="true">*</span>}</label>
	}
	<div class="phone-group">
		<app-select
			class="phone-code"
			[formControl]="prefixControl"
			[options]="countryCodeOptions"
			[showIcon]="true"
			[size]="size"
			[appendTo]="null"
		></app-select>
		@if (showCustomPrefix) {
			<app-input
				class="custom-phone-code"
				[placeholder]="'+XXX'"
				[size]="size"
				[formControl]="customPrefixControl"
				(blur)="onBlur()"
			></app-input>
		}
		<app-input
			class="phone-number"
			[placeholder]="placeholder"
			[size]="size"
			type="tel"
			[inputId]="phoneInputId"
			[required]="required"
			[formControl]="phoneControl"
			[error]="error"
			(blur)="onBlur()"
		></app-input>
	</div>
	@if (error && errorMessage) {
		<span class="error-message">{{ errorMessage }}</span>
	}
</div>
